export const SESSION_SWITCH_FLAG_KEY = "sessionSwitchInProgress";
export const SESSION_SWITCH_TS_KEY = "sessionSwitchStartedAt";
const SWITCH_TIMEOUT_MS = 1000 * 60; // safety: 1 minute

export const markSessionSwitchStart = () => {
	try {
		if (typeof window === "undefined" || !window.sessionStorage) {
			return;
		}
		window.sessionStorage.setItem(SESSION_SWITCH_FLAG_KEY, "true");
		window.sessionStorage.setItem(
			SESSION_SWITCH_TS_KEY,
			Date.now().toString()
		);
	} catch (error) {
		console.error("Unable to persist session switch flag", error);
	}
};

export const clearSessionSwitchFlag = () => {
	try {
		if (typeof window === "undefined" || !window.sessionStorage) {
			return;
		}
		window.sessionStorage.removeItem(SESSION_SWITCH_FLAG_KEY);
		window.sessionStorage.removeItem(SESSION_SWITCH_TS_KEY);
	} catch (error) {
		console.error("Unable to clear session switch flag", error);
	}
};

export const hasStaleSessionSwitchFlag = () => {
	try {
		if (typeof window === "undefined" || !window.sessionStorage) {
			return false;
		}
		const flag = window.sessionStorage.getItem(SESSION_SWITCH_FLAG_KEY);
		if (flag !== "true") {
			return false;
		}
		const ts = Number(
			window.sessionStorage.getItem(SESSION_SWITCH_TS_KEY) || "0"
		);
		if (!ts) {
			return true;
		}
		return Date.now() - ts > SWITCH_TIMEOUT_MS;
	} catch (error) {
		console.error("Unable to read session switch flag", error);
		return false;
	}
};

export const isSessionSwitchInProgress = () => {
	try {
		if (typeof window === "undefined" || !window.sessionStorage) {
			return false;
		}

		const flag = window.sessionStorage.getItem(SESSION_SWITCH_FLAG_KEY);
		if (flag !== "true") {
			return false;
		}

		if (hasStaleSessionSwitchFlag()) {
			clearSessionSwitchFlag();
			return false;
		}

		return true;
	} catch (error) {
		console.error("Unable to determine session switch flag", error);
		return false;
	}
};


